import { render, staticRenderFns } from "./BsaExternalVariables.vue?vue&type=template&id=8c85d982"
import script from "./BsaExternalVariables.vue?vue&type=script&lang=js"
export * from "./BsaExternalVariables.vue?vue&type=script&lang=js"
import style0 from "./BsaExternalVariables.vue?vue&type=style&index=0&id=8c85d982&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c85d982')) {
      api.createRecord('8c85d982', component.options)
    } else {
      api.reload('8c85d982', component.options)
    }
    module.hot.accept("./BsaExternalVariables.vue?vue&type=template&id=8c85d982", function () {
      api.rerender('8c85d982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bsa/BsaExternalVariables.vue"
export default component.exports